module.exports = __webpack_public_path__ + "static/media/6valkas_edited.2427b1ff.jpg";